/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForeignExperience } from '../../models/foreign-experience';

export interface GetForeignExperience$Params {
  profileId: string;
  id: string;
}

export function getForeignExperience(http: HttpClient, rootUrl: string, params: GetForeignExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<ForeignExperience>> {
  const rb = new RequestBuilder(rootUrl, getForeignExperience.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForeignExperience>;
    })
  );
}

getForeignExperience.PATH = '/studentprofile/{profileId}/foreignexperience/{id}';
